export enum PaymentStatus {
  UNPAID = 'UNPAID',
  RESERVED = 'RESERVED',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PAID = 'PAID',
  UNUSED = 'UNUSED',
  PARTIALLY_USED = 'PARTIALLY_USED',
  USED = 'USED',
}
